/* eslint-disable */
import ko from 'knockout';
import _ from 'underscore';
var i18n = window.globalLegacyI18n.get('module/extension/requirejs/i18n!uet');
const tranformFileName = function (filename) {
  if (!filename || filename.length <= 25) {
    return filename;
  }
  var preFileName = filename.substr(0, 12);
  var postFileName = filename.substr(filename.length - 12, 12);
  var newFileName = preFileName + '...' + postFileName;
  return newFileName;
};
export default function (model) {
  this.maximumFileSize = _.constant(200 * 1024 * 1024);
  this.enableUpload = ko.observable(false);
  this.showWarning = ko.observable(false);
  this.warningMessage = ko.observable('');
  this.fileName = ko.observable('');
  const {OnlineConversionRestateRetractUI} = model;
  this.showUploadButton = ko.observable(model.isNewUI);
  if (!OnlineConversionRestateRetractUI) {
    this.uploadButtonClicked = (function () {
      this.showUploadButton(false);
    }).bind(this);
    this.cancelButtonClicked = (function () {
      this.showUploadButton(true);
    }).bind(this);
  }
  this.fileDidPick = (function (inputElement) {
    if (!_.isUndefined(inputElement.files) && inputElement.files.length > 0) {
      var file = _.first(inputElement.files);
      var fileSizeExceeded = file && file.size && file.size >= this.maximumFileSize();
      var fileEmpty = file && file.size <= 0;
      if (!fileEmpty) {
        this.fileName(tranformFileName(file.name));
      }
      var fileNameIsInvalid = file && (function (name) {
        var reg = /\.([^\.]+)$/;
        var matches = name.match(reg);
        return !(matches && _.contains(['csv', 'tsv', 'xlsx'], matches[1].toLowerCase()));
      })(file.name);
      if (fileSizeExceeded || fileEmpty || fileNameIsInvalid) {
        this.enableUpload(false);
        this.showWarning(true);
        if (fileNameIsInvalid) {
          this.warningMessage(i18n.getString('UnifiedEventTracking_UploadConversions_Unsupported_Format'));
        } else if (fileEmpty) {
          this.warningMessage(i18n.getString('UnifiedEventTracking_UploadConversions_File_Empty'));
        } else {
          this.warningMessage(i18n.getString('UnifiedEventTracking_UploadConversions_UploadError_FileSizeExceeded'));
        }
      } else {
        this.enableUpload(true);
        this.showWarning(false);
        this.warningMessage('');
      }
    }
  }).bind(this);
}

